import axios from '../utils/axios';

export default function activateSeekerPlan(adminId, body) {
    return axios.post(`/admin/${adminId}/jobseeker-admin/v2/admin-recruiter/activatesubscription`, body);
};